// Copyright (c) 2022 by Move Closer

import { PropType } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'
import { FormControlModelType, FormControlType } from '../../abstract/general'
import { getAbstractInputControlProps } from '../../abstract/components/InputControl/InputControl.hooks'

import { InputProps } from './Input.contracts'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl> (original)
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl> (edited)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export const customInputProps: ComponentObjectPropsOptions<InputProps> = {
  ...getAbstractInputControlProps<FormControlModelType>(),

  /**
   * Determines whether input has visible label.
   */
  hasVisibleLabel: {
    type: Boolean as PropType<FormControlModelType>,
    required: false,
    default: true
  },

  /**
   * Value for the `[type]` attribute.
   */
  type: {
    type: String as PropType<FormControlType>,
    required: false,
    default: 'text'
  }
}
